import axios from "axios";
import { getBaseUrl, Microservice } from "../constant/baseUrl";
import { getApiResponseErrorMsg } from "../Utils/apiHelper";

interface VerifyTwoFATokenRequest {
  token: string;
  email: string;
  persona?: string;
}

const verifyTwoFAToken = async ({
  token,
  email,
  persona,
}: VerifyTwoFATokenRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/auth/verify-two-factor-token`,
      { token, email, persona },
      { withCredentials: true },
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    (e as Error).message = message;
    throw e;
  }
};

export default verifyTwoFAToken;
